import { useEffect, useState } from 'react';
import { getKpiUsage } from '@src/api/SPI';

const IN_USE_WARNING =
  'This custom KPI is used by AI Alerts and cannot be deleted. Select another KPI in AI Alerts configuration and save your changes before deleting it.';

export default function useKpiDeletionUsage(kpiId: number, isModalOpen: boolean) {
  const [usageWarning, setUsageWarning] = useState('');
  const [usage, setUsage] = useState<{ kpiId: number; status: 'checking' | 'ready' | 'error' }>();
  const [retryCount, setRetryCount] = useState(0);
  useEffect(() => {
    let active = true;
    setUsageWarning('');
    setUsage(undefined);
    if (isModalOpen) {
      setUsage({ kpiId, status: 'checking' });
      getKpiUsage(kpiId)
        .then(({ data }) => {
          if (typeof data?.inUseByAiAlerts !== 'boolean') {
            throw new Error('Invalid KPI usage response');
          }
          if (active) {
            setUsageWarning(data.inUseByAiAlerts ? IN_USE_WARNING : '');
            setUsage({ kpiId, status: 'ready' });
          }
        })
        .catch(() => {
          if (active) setUsage({ kpiId, status: 'error' });
        });
    }
    return () => {
      active = false;
    };
  }, [isModalOpen, kpiId, retryCount]);
  const canDelete =
    isModalOpen && usage?.kpiId === kpiId && usage?.status === 'ready' && !usageWarning;
  return {
    canDelete,
    usageWarning,
    setUsageWarning,
    isChecking: isModalOpen && (usage?.kpiId !== kpiId || usage?.status === 'checking'),
    hasError: usage?.kpiId === kpiId && usage?.status === 'error',
    retry: () => setRetryCount((count) => count + 1),
  };
}
